<template>
    <div class="upload_template_form_div">
        <group-card title="Upload Templates" icon="attach_file">
            <ValidationObserver ref="form_upload_template">
                <form enctype="multipart/form-data">
                    <md-dialog-alert
                        :md-active.sync="alertMessage"
                        md-title=" "
                        :md-content="message" />
                    <md-progress-spinner md-mode="indeterminate" v-if="loading"></md-progress-spinner>
                    <div class="md-layout">

                        <!-- Template Upload -->
                        <md-field>
                            <label>Upload Template, docx only</label>
                            <md-file v-model="single" name="file" @change="onFileChange" required />
                        </md-field>

                        <!-- Template Type -->
                        <md-field>
                            <label>Select a Template Type</label>
                            <md-select v-model="template_type_id" name="template_type" required>
                                <md-option :value="0" key="0" select="select">Select a Template Type</md-option>
                                <md-option v-for="template_type in template_type_names" :value="template_type.id" :key="template_type.id">{{ template_type.name }}</md-option>
                            </md-select>
                        </md-field>

                        <!-- Template displaying name -->
                        <md-field>
                            <label>Template Description</label>
                            <md-input v-model="description" />
                        </md-field>

                        <!-- Search -->
                        <div>
                            <md-button class="md-primary md-simple md-danger" @click="clearForm">Cancel</md-button>
                            <md-button class="md-primary" @click="uploadTemplate">Upload</md-button>
                        </div>

                    </div>
                </form>
            </ValidationObserver>
        </group-card>
      <LinkDocuSignTemplateForm :templates="template_type_names"></LinkDocuSignTemplateForm>
      <DefaultDocusignEmailTemplateForm></DefaultDocusignEmailTemplateForm>
    </div>
</template>

<script>
import { GroupCard } from "@/components";
import { ValidatedTextInput } from "@/components";
import LinkDocuSignTemplateForm from "./LinkDocuSignTemplateForm";
import DefaultDocusignEmailTemplateForm from "./DefaultDocusignEmailTemplateForm";

export default {
    components: {
        DefaultDocusignEmailTemplateForm,
        LinkDocuSignTemplateForm,
        GroupCard,
        ValidatedTextInput
    },
    data() {
        return {
            alertMessage: false,
            message: '',
            file: null,
            display_name: '',
            single: '',
            description: '',
            loading: false,
            template_type_names: [],
            template_type_id: '',
        }
    },
    beforeMount() {
        this.fetchTemplateTypes();
    },
    methods: {
        clearForm() {
            this.file.value = null;
            this.single = '';
            this.display_name = '';
            this.description = '';
            this.template_type_id = '';
            this.loading = false;
        },
        onFileChange(event) {
            this.file = event.target.files[0];
            this.single = this.file.name;
        },
        async fetchTemplateTypes() {
            let response = await axios.get('/api/v1/get-template-types')
                .then(response => {
                    this.template_type_names = response.data;
                })
                .catch(error => (console.log(error)
                ));
        },
        async uploadTemplate() {

            this.loading = true;

            const payload = {
                'file': this.file,
                'description': this.description,
                'template_type_id': this.template_type_id,
            };

            if (this.file === null || this.file === undefined) {
                this.loadmessage('template is not available');
            } else if (this.template_type_id === null || this.template_type_id === undefined || this.template_type_id == 0) {
                this.loadmessage('Please select a template type');
            } else {
                try {
                    let result = await this.$store.dispatch('store_doc_template', payload)
                    if (result) {
                        this.loadmessage('upload template success');
                        this.clearForm();
                    } else {
                        console.log(error);
                        this.loadmessage('failed to upload template');
                    }
                } catch (error) {
                    console.log(error);
                    this.loadmessage('failed to upload template');
                }
            }
            setTimeout(() => this.alertMessage = false, 5000);
        },

        loadmessage(message) {
            this.alertMessage = true;
            this.message = message;
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .upload_template_form_div {
        width: 49%;
        float: right;
    }

    div.md-field.md-theme-default {
        margin-left: 15px;
        margin-right: 15px;
    }

    div.md-menu-content.md-select-menu {
        max-width: 40% !important;
    }
</style>
